import axios from "axios";
import Utils from "../utils/utils";

export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const LOGOUT_USER = "LOGOUT_USER";

const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;

export const fetchUserRequest = () => ({
  type: FETCH_USER_REQUEST,
});

export const fetchUserSuccess = (user) => {
  return {
    type: FETCH_USER_SUCCESS,
    payload: { user, token: Utils.getToken() }, // Include token in payload
  };
};

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const fetchUserFailure = (error, status) => ({
  type: FETCH_USER_FAILURE,
  payload: { error: "Something went wrong: " + error.message, status },
});

export const fetchUserData = () => {
  return async (dispatch) => {
    dispatch(fetchUserRequest());

    const user = Utils.getLoggedInUser();
    const token = Utils.getToken();
    const role = Utils.UserRole;
    const userIs = role && role.toLowerCase() === "admin" ? "admin" : "student";

    if (!user || !token) {
      dispatch(
        fetchUserFailure(new Error("User not logged in or token missing."), 401)
      );
      return;
    }

    try {
      if (userIs === "admin") {
        const res = await axios.get(`${SERVER_URL}/admin/${user.userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const admin = res.data;
        admin["role"] = "admin";
        dispatch(fetchUserSuccess(admin));
      } else if (userIs === "student") {
        const res = await axios.get(`${SERVER_URL}/students/${user.userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const student = res.data;
        student["role"] = "student";
        dispatch(fetchUserSuccess(student));
      }
    } catch (error) {
      let status = error.response ? error.response.status : 500;
      if (error.message === "Network Error") {
        Utils.logOut();
        dispatch(logoutUser());
      }
      dispatch(fetchUserFailure(error, status));
    }
  };
};

// userActions.js
